import { render, staticRenderFns } from "./WAccountEditPass.vue?vue&type=template&id=a4b2d1be&"
import script from "./WAccountEditPass.vue?vue&type=script&lang=ts&"
export * from "./WAccountEditPass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports